import { FeaturedImage } from "@hatch-digital-nl/abs-storybook/legacy";
import { useGetEstablishmentByIdQuery } from "../../../../common/api/establishment";
import Skeleton from "react-loading-skeleton";
import { useEstablishmentId } from "../../../../common/utils/useEstablishmentId";
import { JSX } from "react";

export const DashboardEstablishmentInfo = (): JSX.Element | null => {
    const {
        data: establishmentData,
        isLoading: establishmentIsLoading,
        isFetching: establishmentIsFetching,
    } = useGetEstablishmentByIdQuery({ id: useEstablishmentId() });

    if (establishmentIsLoading || establishmentIsFetching) {
        return <Skeleton height={"25rem"} borderRadius={"1.5rem"} />;
    }

    if (!establishmentData) {
        return null;
    }

    const { name, image_url, address } = establishmentData;
    const houseNumber = address.house_number_addition
        ? address.house_number + address.house_number_addition
        : address.house_number;

    return (
        <FeaturedImage
            imageUrl={image_url}
            title={name}
            address={
                address.street +
                " " +
                houseNumber +
                ", " +
                address.zip_code +
                " " +
                address.city
            }
            badge={establishmentData.badge}
        />
    );
};
